/** Fast-fall speeds the clock only after the sine jump starts coming down. */
export const FAST_FALL_APEX_T = 0.5;

export function jumpProgress(actionMs: number, actionDuration: number): number {
  if (actionDuration <= 0) {
    return 1;
  }
  return actionMs / actionDuration;
}

export function canStartFastFall(jumping: boolean, alreadyFastFalling: boolean, t: number): boolean {
  return jumping && !alreadyFastFalling && t < 0.95;
}

export function jumpActionDeltaMs(deltaMs: number, t: number, fastFalling: boolean, mul: number): number {
  if (fastFalling && t >= FAST_FALL_APEX_T) {
    return deltaMs * mul;
  }
  return deltaMs;
}
